<!-- Hero Banner Section -->
<section
    class="relative bg-gradient-to-b from-[#102B51] via-[#163564] to-[#0D2240] text-white py-16 md:py-24 overflow-hidden">
    <!-- Decorative Ambient Glows -->
    <div class="absolute -top-24 -left-24 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none"></div>
    <div class="absolute top-1/2 -right-24 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl pointer-events-none"></div>

    <div class="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div class="text-center max-w-3xl mx-auto space-y-4">
            <h1 class="text-3xl sm:text-4xl md:text-6xl font-bold tracking-tight text-white leading-tight">
                Rolly <span class="text-emerald-400">Videobooth 360</span>
            </h1>

            <p class="text-gray-300 text-sm md:text-lg leading-relaxed max-w-2xl mx-auto">
                Abadikan momen seru dan spektakuler bareng Videobooth
                interaktif 360 derajat Visidea Studio. Hasilrekaman sinematik
                bernuansa slow-motion plus custom frame overlay unik bisa
                langsung kamu download praktis via QR code.
            </p>

            <!-- Quick Trust Badges -->
            <div
                class="pt-4 flex flex-wrap justify-center items-center gap-4 md:gap-8 text-xs md:text-sm text-gray-300">
                <div class="flex items-center gap-2">
                    <svg class="w-5 h-5 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>Cinematic 360° Slow-Motion</span>
                </div>
                <div class="flex items-center gap-2">
                    <svg class="w-5 h-5 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>Real-Time Softfile via QR</span>
                </div>
                <div class="flex items-center gap-2">
                    <svg class="w-5 h-5 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>Custom Overlay & IT Support</span>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="py-10 md:py-16 px-6 md:px-8 bg-white">
    <div class="max-w-7xl mx-auto">
        <div class="grid grid-cols-1 md:grid-cols-2 items-center gap-8 md:gap-14">
            <div class="flex justify-center items-center">
                <img src="/assets/visidea/360rolly-photobooth.PNG"
                    class="w-full max-w-[440px] md:max-w-[480px] rounded-3xl shadow-lg object-cover"
                    alt="Rolly Videobooth">
            </div>
            <div class="space-y-3">
                <div class="text-2xl md:text-4xl font-normal text-[#102B51]">
                    Rolly <span class="font-semibold">Videobooth</span>
                </div>
                <div class="text-base md:text-xl text-gray-500 leading-relaxed">
                    Videobooth interaktif persembahan Visidea Studio ini
                    siap merekam video sinematik 360 derajat. Semua tamu
                    bebas jadi bintang berpose stylish dan langsung dapat
                    video keren siap diunggah ke sosmed. Kekinian, fun serta
                    pasti jadi pusat perhatian utama di event.
                </div>
            </div>
        </div>
    </div>
</section>

<section class="py-20 px-8 bg-white relative">
    <img src="/assets/visidea/orn_kanan.png" class="absolute top-[355px] right-[0px] w-24 hidden md:block" alt="">
    <div class="max-w-7xl mx-auto">
        <div class="text-2xl md:text-4xl text-center font-normal mb-2">
            Pricelist
        </div>
        <div class="text-2xl md:text-4xl text-center font-normal mb-12">
            Rolly <span class="font-semibold">Videobooth</span>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="flex justify-center items-center py-20">
            <div class="text-gray-500">Memuat paket...</div>
        </div>

        <!-- Pricing Cards Grid - Dynamic -->
        <div *ngIf="!isLoading && packages.length > 0" class="videobooth-package-grid mb-12 mt-12">
            <div *ngFor="let pkg of packages"
                class="bg-[#F8FAFC] border-4 border-transparent hover:border-[#202367] hover:bg-white hover:shadow-2xl hover:scale-105 hover:ring-4 hover:ring-[#202367]/10 rounded-3xl overflow-hidden flex flex-col p-6 transition-all duration-300 relative group">
                <div class="bg-white border border-gray-100 group-hover:bg-[#F4F7FF] group-hover:border-[#202367]/20 p-6 rounded-2xl mb-6 transition-colors min-h-[120px] flex flex-col justify-center">
                    <h3 class="text-2xl md:text-3xl font-extrabold text-[#102B51] mb-2 capitalize leading-tight">{{ pkg.name }}</h3>
                    <div class="text-3xl md:text-4xl font-black text-[#202367]">{{ formatCurrency(pkg.price) }}</div>
                    <div *ngIf="pkg.regularPrice && pkg.regularPrice !== pkg.price" class="text-sm text-gray-400 line-through mt-1">
                        {{ formatCurrency(pkg.regularPrice) }}
                    </div>
                </div>
                <div class="flex-1 flex flex-col justify-between">
                    <ul class="space-y-3 flex-1">
                        <li *ngFor="let feature of pkg.features" class="flex items-start gap-3">
                            <span class="text-[#202367] text-lg shrink-0">◆</span>
                            <span class="text-gray-700 text-sm md:text-base font-medium capitalize">{{ feature }}</span>
                        </li>
                    </ul>
                    <div class="videobooth-package-actions">
                        <button type="button" class="videobooth-package-button videobooth-package-button--cart"
                            (click)="addToCart(pkg)">
                            <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                            <span>Keranjang</span>
                        </button>
                        <button type="button" class="videobooth-package-button videobooth-package-button--checkout"
                            (click)="checkout(pkg)">
                            <span>Checkout</span>
                            <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoading && packages.length === 0" class="text-center py-20">
            <p class="text-gray-500">Belum ada paket tersedia</p>
        </div>
    </div>
</section>


<section class="py-12 md:py-20 px-4 md:px-8 bg-[#F1F1F1]">
    <div class="max-w-7xl mx-auto">
        <div class="text-2xl md:text-4xl text-center font-normal mb-2">
            Hasil Video
        </div>
        <div class="text-2xl md:text-4xl text-center font-normal mb-12">
            Rolly <span class="font-semibold">Videobooth</span>
        </div>

        <!-- Video 360 Carousel (7 Videos) -->
        <div class="splide videobooth-splide relative px-2 md:px-6" #splideElement>
            <div class="splide__track py-4">
                <ul class="splide__list">
                    <li class="splide__slide" *ngFor="let video of videos; let i = index">
                        <div
                            class="relative bg-black rounded-3xl overflow-hidden shadow-2xl border-4 border-white group/card h-[580px] sm:h-[640px] md:h-[700px] lg:h-[720px] flex items-center justify-center">
                            <!-- Video Player -->
                            <video [id]="'videobooth-sample-' + i" #videoEl [src]="video.src" autoplay
                                [muted]="video.isMuted" muted loop playsinline webkit-playsinline preload="auto"
                                class="w-full h-full object-cover rounded-2xl">
                                Browser Anda tidak mendukung tag video HTML5.
                            </video>

                            <!-- Gradient Overlay -->
                            <div
                                class="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/30 pointer-events-none">
                            </div>

                            <!-- Floating Sound Button (Top-Right) -->
                            <button (click)="toggleSound(i, videoEl, $event)" type="button"
                                class="absolute top-4 right-4 z-20 px-3.5 py-2 rounded-full text-xs font-semibold backdrop-blur-md transition-all duration-300 flex items-center gap-1.5 shadow-lg active:scale-95 cursor-pointer border"
                                [ngClass]="video.isMuted ? 'bg-black/60 hover:bg-black/80 text-white border-white/20' : 'bg-emerald-500 hover:bg-emerald-600 text-white border-emerald-400 ring-2 ring-emerald-300/50'">
                                <!-- Muted Icon -->
                                <svg *ngIf="video.isMuted" class="w-4 h-4" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
                                </svg>
                                <!-- Unmuted Icon -->
                                <svg *ngIf="!video.isMuted" class="w-4 h-4" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                                </svg>
                                <span>{{ video.isMuted ? 'Bisu' : 'Suara Aktif' }}</span>
                            </button>

                            <!-- Bottom Title Pill -->
                            <div
                                class="absolute bottom-4 left-4 right-4 z-10 flex items-center justify-between text-white pointer-events-none">
                                <span
                                    class="text-xs font-semibold px-3 py-1 bg-black/40 backdrop-blur-md rounded-full border border-white/20">
                                    {{ video.title }}
                                </span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>